<section
  [id]="'workflow-configuration-step-action-' + actionIndex()"
  [formGroup]="formGroup()">
  <div class="grid grid-cols-2 max-w-[51rem] gap-lg">
    <div>
      <lib-select
        [label]="'workflow_step_info_form_when_label' | transloco"
        [inputFormControlName]="'when'"
        [id]="'trigger-' + actionIndex()"
        [name]="'when-' + actionIndex()"
        [options]="whenOptions()"
        [selectedKeyName]="'label'"
        [selectedKeyValue]="'value'"
        [placeholder]="
          'workflow_step_info_form_select_when_placeholder' | transloco
        "
        [required]="true" />

      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="when" />
    </div>

    <div>
      <lib-select
        [label]="'workflow_step_info_form_action_label' | transloco"
        [inputFormControlName]="'type'"
        [id]="'type-' + actionIndex()"
        [name]="'type-' + actionIndex()"
        [options]="actionOptions()"
        [selectedKeyName]="'label'"
        [selectedKeyValue]="'value'"
        [placeholder]="
          'workflow_step_info_form_select_action_placeholder' | transloco
        "
        [required]="true" />

      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="type" />
    </div>

    <div
      [id]="'workflow-configuration-step-action-users-' + actionIndex()"
      class="min-w-[10rem]">
      @let contributorsCount = userCount();
      @let hasNoUsers = showCustomToggleButton();
      @let inAddMode = hasNoUsers || isAddMode();
      @let canRemoveSelectedUsers = canRemoveUsers();
      @let currentList = inAddMode ? userDropdownList() : selectedUsers();
      @let meta = userDropdownMeta();

      <lib-user-dropdown-view
        [userCount]="contributorsCount"
        [userTableList]="selectedUsers()"
        [userDropdownList]="currentList"
        [isDropdownLoading]="isLoadingDropdown()"
        [currentDropdownPage]="meta?.current_page ?? 0"
        [totalDropdownPages]="meta?.last_page ?? 0"
        [totalDropdownCount]="
          inAddMode ? (meta?.total ?? 0) : contributorsCount
        "
        [containerRef]="
          'workflow-configuration-step-action-users-' + actionIndex()
        "
        [showIndividualAvatar]="!contributorsCount"
        [allowLeftPositioning]="true"
        [enableDropdownIcon]="!!contributorsCount"
        [enableAddItem]="inAddMode"
        (addItem)="addUser($event)"
        [enableDeleteItem]="canRemoveSelectedUsers"
        (deleteItem)="removeUser($event)"
        [croppedNumber]="contributorsCount < 4 ? selectedUsers().length : 4"
        [trimLength]="18"
        [allowCustomToggleButton]="true"
        [enableLocalSearch]="!inAddMode"
        [toggleContainerClass]="'justify-start gap-sm w-full'"
        [imgDimensions]="{ width: 1.5, height: 1.5 }"
        (handleMenuToggle)="handleMenuToggle($event)"
        (openedMenu)="resetDropdown($event)"
        [searchLabel]="'dropdown_search_find_users_label' | transloco"
        [searchPlaceholder]="'search_by_name_placeholder' | transloco"
        [headerListLabel]="'workflow_step_info_form_users_label' | transloco"
        [noSearchResultLabel]="'no_search_result_label' | transloco">
        @if (hasNoUsers) {
          <div custom-list-toggle-button class="w-full flex">
            <ng-container [ngTemplateOutlet]="add_user" />
          </div>
        }

        @if (canRemoveSelectedUsers) {
          <div additional-menu-overlay-actions class="w-full">
            <button
              [id]="'add-users-' + actionIndex()"
              type="button"
              (click)="switchToAddMode()"
              class="text-primary-500 flex justify-center items-center text-sm py-sm font-medium">
              <ng-container [ngTemplateOutlet]="add_user" />
            </button>
          </div>
        }
      </lib-user-dropdown-view>

      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="user_ids" />
    </div>
  </div>
</section>

<ng-template #add_user>
  <p
    class="text-primary-500 flex justify-center items-center text-sm py-sm font-medium">
    <lib-add-icon iconClass="size-4 text-primary-500 me-sm" />
    {{ 'workflow_step_info_form_users_placeholder' | transloco }}
  </p>
</ng-template>
